import { NewDefaultTheme, ThemeData } from "../../api/personalization/theme/data"
import { useThemeStore } from "../../api/personalization/theme/store"
import useUXStore from "../../api/ux/store"
import ButtonControl from "../../components/ButtonControl"
import Loading from "../../components/Loading"
import ThemeDropdown from "../../containers/Theming/ThemeDropdown"
import ThemeList from "../../containers/Theming/ThemeList"
import ThemeView from "../../containers/Theming/ThemeView"

const Theming = () => {
    const {pushPage} = useUXStore( state => state)
    const {themes,loading, retrieveThemes, defaultTheme, setDefaultTheme} = useThemeStore( state => state)
    const onSelectTheme = (selectedTheme:ThemeData) => {
        pushPage(selectedTheme.Code,  <ThemeView theme={selectedTheme}/>)
    }
    const onChangedDefault = (selectedTheme: number) => {
        setDefaultTheme(selectedTheme)
    }
    if (!loading && themes === null)  {
        retrieveThemes()
    }
    const onAdd = () => {
        pushPage("New Theme", <ThemeView isnew theme={NewDefaultTheme}/>)
    }
    return <>
        {loading && <Loading expandHeight />}
        {!loading && <ThemeDropdown selected={defaultTheme} themes={themes} onSelected={onChangedDefault}/>}
        {!loading && <ThemeList themes={themes} onClick={onSelectTheme}/>}
        {!loading && <ButtonControl text="Add theme" buttonLabel="Add" onClicked={onAdd}/>}
    </>
}

export default Theming